import type { TOC } from '@ember/component/template-only';

import BoardLoopsIndexTableComponent from 'webapp/components/board-loops/index/table';
import EmptyScreensBoardLoopsComponent from 'webapp/components/empty-screens/board-loops';
import TemplatesPublicRecommendedBoardLoopsComponent from 'webapp/components/templates/public/recommended-board-loops';
import type BoardsLoopsIndexController from 'webapp/controllers/boards/loops/index';

interface Args {
	controller: BoardsLoopsIndexController;
}

const BoardsLoopsIndexRouteTemplate: TOC<Args> = <template>
	{{#if @controller.boardLoopsEnabled}}
		<div class="container__recommended">
			{{#if @controller.hasLoops}}
				<div id="board-loops" class="view-table">
					<BoardLoopsIndexTableComponent
						@model={{@controller.boardLoops}}
						@onCreate={{@controller.createNew}}
						@onOpenPreview={{@controller.openPreview}}
						@onEdit={{@controller.edit}}
						@onToggleFavorite={{@controller.toggleFavorite}}
						@onShare={{@controller.share}}
						@onOpenFullscreenView={{@controller.openFullscreenView}}
						@onOpenInDesigner={{@controller.openInDesigner}}
						@onDuplicate={{@controller.duplicate}}
						@onCreateReport={{@controller.createReport}}
						@onDelete={{@controller.delete}}
						@onSaveAsTemplate={{@controller.saveAsTemplate}}
						@onRestore={{@controller.restore}}
						@onDeletePermanently={{@controller.deletePermanently}}
						@updateIsRecentlyDeletedFilterActive={{@controller.updateRecentlyDeletedFilter}}
					/>
				</div>
			{{else}}
				<EmptyScreensBoardLoopsComponent />
			{{/if}}

			<TemplatesPublicRecommendedBoardLoopsComponent
				@isHidden={{@controller.hideRecommendedTemplates}}
			/>
		</div>
	{{else}}
		<EmptyScreensBoardLoopsComponent />
	{{/if}}
</template>;

export default BoardsLoopsIndexRouteTemplate;
